<div style="margin: 16px; padding-bottom: 1px;">
    <div style="margin: auto;" [style.width]="authService.isLoggedIn()? '100%': '80%'">
        <div style="padding: 16px; width: 100%; background: #fff; font-size: 14px; font-weight: 500; border-radius: 8px;"
            class="card-item app-shadow">
            <div *ngIf="!vendor">

                <nz-alert nzType="warning" nzMessage="Warning"
                    nzDescription="Not found any docs for you please contact with administrator." nzShowIcon></nz-alert>
            </div>
            <div *ngIf="vendor">
                <div class="text-center font-18 font-weight-700" style="margin-bottom: 15px;">
                    {{vendor}} Api Doc
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        Get product list api
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="productsByNameApi"></app-copy-to-clipboard>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{successRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Wrong service name response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{wrongServiceRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        Checkout api(Initiate charging)
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="createCheckoutSessionApi"></app-copy-to-clipboard>


                    During First time charging, Auto Renewal and one time subscription, <strong> every time channel must
                        to
                        be passed (case sensitive).</strong> Channel names are :
                    <ul>
                        <li>
                            MYGP:
                            When traffic redirected or initiated from MyGP App
                        </li>
                        <li>
                            NCND:
                            When traffic redirected or initiated from NCND website
                        </li>
                        <li>
                            SelfWeb:
                            When traffic initiated from the web site itself
                        </li>
                        <li>
                            SelfApp:
                            When traffic initiated from the App itself
                        </li>
                        <li>
                            SKITTO:
                            When traffic redirected or initiated from SKITTO App
                        </li>
                        <li>
                            Others:
                            When traffic initiated from any other digital marketing channel like google, facebook,
                            affiliated marketing etc.
                        </li>
                    </ul>

                </div>
                <div class="font-italic">
                    Reqeust body:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{reqBody}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{reqSucRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Server error response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{reqServerErrorRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        Subscription check api
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="checkSubscriptionByNameApi"></app-copy-to-clipboard>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{checkReqRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Not found subscription Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{checkNotFoundRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        Subscription cancel api
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="cancelSubscriptionApi"></app-copy-to-clipboard>
                    <div>
                        <span class="font-weight-600">
                            Api key(need to pass in header):
                        </span>
                        <span style="font-style: italic;">x-api-key</span>
                    </div>
                    <div>
                        <span class="font-weight-600">
                            Value:
                        </span>
                        <span style="font-style: italic;">check it in
                            <span class="app-link">cancelApiEncryptionDoc</span>
                        </span>
                    </div>
                </div>
                <div>
                    <div class="font-italic">
                        Reqeust body:
                    </div>
                    <div class="code-block-container">
                        <pre class="code-block">
                    <code>
                        <span>
    "8m9XxNZx0MdaJmTvOyzKD6WWZmvd6t0/cqueBUIOdGXRIv0lbJKOC3AFeRZ/w+0ZZ6TCcFxAd4hFOKVaG/ri3w=="
                        </span>
                    </code>
                </pre>
                    </div>
                    <div class="font-16">
                        Note:
                    </div> Here Request body is a encrypted string. See more about encryption in
                    <span class="app-link">cancelApiEncryptionDoc</span>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{cancelReq}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Failed Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{cancelRes}}
                    </span>
                </code>
            </pre>
                </div>

                <!-- How to configure Notification : Start-->
                <div>
                    <h1>
                        Setup Notification
                    </h1>
                    <p>Set up the notification mechanism within the provider's system to send notifications to provider
                        after completing a payment
                        transaction. This involves configuring the HTTPS API endpoint to receive notifications and
                        defining the parameters
                        required for notification delivery.</p>


                    <h2>Notification Parameters</h2>
                    After completing a payment transaction,sending notifications through the HTTPS API:

                    <ul>
                        <li>Notification URL: The URL where the HTTPS API endpoint is hosted by the provider.</li>
                        <li>MSISDN: The mobile number associated with the user's account, which is charged or
                            undergoing an action
                            (e.g., activation,deactivation, charge renewal).</li>
                        <li>ServiceID: Unique identifier for the service notifying the user.</li>
                        <li>ActionType: Type of action being notified (e.g. ACT, REN, DACT).</li>
                        <ul>
                            <li>ACT : Activation</li>
                            <li>DACT : Deactivation</li>
                            <li>REN : Renewal</li>
                        </ul>
                        <li>ActionMessage: ActionType description or notification content. (e.g. deactivation, Charged)
                        </li>
                        <li>
                            TransactionId: TransactionId is a unique identifier assigned to each payment transaction.
                        </li>
                    </ul>

                    <h2>Sample Notification URL</h2>
                    <p>The HTTPS API notification URL format for sending notifications to users is as follows:</p>

                    <div class="code-block-container">
                        <pre class="code-block">
                                <code>
                                    <span
                                        style="padding: 10px;">{{"https://www.example.com/notification?msisdn={msisdn}&ServiceID={serviceId}&ActionType={action}&ActionMessage={messageId}&transactionId={trxId}"}}</span>
                                </code>
                            </pre>
                    </div>

                </div>

                <!-- How to configure Notification : End-->

            </div>
        </div>
    </div>
</div>